import script from "./ViewWall.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewWall.vue?vue&type=script&setup=true&lang=js"

import "./ViewWall.vue?vue&type=style&index=0&id=21ee73a1&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21ee73a1"]])

export default __exports__